import { createTheme } from '@mui/material/styles'

// Create a theme instance.

const theme = createTheme({
  palette: {
    primary: {
      main: '#6633CC',
    },
    secondary: {
      main: '#00CC99',
    },
    error: {
      main: '#E15656',
    },
    success: {
      main: '#41A966',
    },
    warning: {
      main: '#FFD15A',
    },
    info: {
      main: '#3773c2',
    },
    background: { default: '#2B2F42' },
  },
  gradient: {
    main: 'linear-gradient(91.95deg, #6633CC 4.33%, #00CC99 149.49%)',
  },
  typography: {
    fontFamily: 'Titillium Web',
    h4: {
      '@media (max-width:600px)': {
        fontSize: '1.7rem',
      },
    },
  },
  fontFamilyBody: 'Lato',
})

declare module '@mui/material/styles' {
  interface Theme {
    gradient: {
      main: string
    }
    fontFamilyBody: string
  }

  interface ThemeOptions {
    gradient?: {
      main?: string
    }
    fontFamilyBody?: string
  }
}

export default theme
